/**
 * Мост валидации Front→Mantine. FormControl инжектит boolean `invalid` через
 * cloneElement; Mantine-инпуты ждут `error`. boolean-only: текст ошибки рендерит
 * FormGroup (НЕ дублируем). error=true → красная рамка без текста; undefined → нет ошибки.
 *
 * Живёт в фасаде Mantine-atom'а, а НЕ в FormControl: легаси-atoms спредят ...props в
 * DOM, поэтому инжект `error` через cloneElement протёк бы DOM-атрибутом в переходный
 * период. FormControl остаётся неизменным.
 */
export const toMantineError = (invalid?: boolean): true | undefined => (invalid ? true : undefined);

/**
 * Плейсхолдер = приглашение к вводу («Введите ИНН», «Выберите контрагента»). В
 * недоступном (disabled/read-only-display) поле это ложный аффорданс — зовёт к
 * действию, которое невозможно, и скринридер зачитывает его как редактируемое.
 * Пустое недоступное поле показывает не приглашение, а маркер отсутствия значения.
 * Переключить на пусто (без прочерка) = заменить на ''.
 */
export const EMPTY_DISPLAY_PLACEHOLDER = '—';
